/**
 * Time & Attendance (employee) tour — Time Logs / timesheet quick start.
 */

export const PEOPLE_TIMESHEET_TOUR_ID = "people-timesheet-v1";

export const PEOPLE_TIMESHEET_TOUR_STEPS = [
  {
    id: "period",
    route: "/people/timesheet",
    selector: "[data-tour='ts-period']",
    title: "Pay period and week",
    description:
      "Choose a current or past pay period. Future periods appear only when you have approved leave that overlaps them (including leave imported from Zoho). On those leave days you can enter hours before the date arrives. Previous / Next moves one Monday–Sunday week at a time.",
    placement: "bottom",
  },
  {
    id: "grid",
    route: "/people/timesheet",
    selector: "[data-tour='ts-grid']",
    title: "Enter hours by job",
    description:
      "Each row is one assigned job. Billable vs non-billable comes from the job and cannot be changed here. Type hours in a day cell, then tab or click away to save. You can log today as you work; certify opens Friday at 4:00 PM (3:00 PM for Patricia Sanabria), or the last working day if Friday is holiday or full-day PTO.",
    placement: "top",
  },
  {
    id: "summary",
    route: "/people/timesheet",
    selector: "[data-tour='ts-summary']",
    title: "Period totals and certify",
    description:
      "Billable, non-billable, and leave hours add up for the pay period. When the week is complete, use Certify & Submit by the period due date.",
    placement: "left",
  },
];
